import React from 'react';
import Slider from "react-slick/lib";
import { BckImg, Line } from "../../Common";
import { feedbackOpts } from '../SliderConfig';

const backgroundStyle = {
  backgroundPosition: 'center center',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
};

const circleStyle = {
  margin: '0 auto',
  marginTop: '15px',
  marginBottom: '30px',
  height: '200px',
  width: '200px',
  borderRadius: '50%',
  backgroundColor: '#ebebeb',
  minWidth: '0px',
  position: 'relative',
  ...backgroundStyle
};

function Reviews() {
  return (
    <Line
      title="Отзывы"
      style={{ margin: '2rem auto'}}
    >
      <div className="carouselcont">
        <Slider {...feedbackOpts}>
          <div className="about__sliding">
            <div className="feedback">
              <BckImg
                src={'/feedback/svet.jpg'}
                thumb={'/feedback/svet-low.jpg'}
                backgroundStyle={circleStyle}
              />
              <h4 className="feedback__name">Светлана</h4>
              <p className="feedback_desc">
                Хочу поблагодарить инструктора Алексея. Он очень опытный, лучший инструктор. Алексей очень
                профессионально, грамотно, тактично подходит
                к обучению. Думаю, что обучаясь с ним, я обязательно сдам город.
              </p>
            </div>
          </div>
          <div className="about__sliding">
            <div className="feedback">
              <BckImg
                src={'/feedback/sviat.jpg'}
                thumb={'/feedback/sviat-low.jpg'}
                backgroundStyle={circleStyle}
              />
              <h4 className="feedback__name">Святослав</h4>
              <span className="feedback_occup">журналист</span>
              <p className="feedback_desc">
                Спасибо инструктору Алексею! Опытный, помог поверить в себя.
                В итоге легко сдал город
              </p>
            </div>
          </div>
          <div className="about__sliding">
            <div className="feedback">
              <BckImg
                src={'/feedback/egor.jpg'}
                thumb={'/feedback/egor-low.jpg'}
                backgroundStyle={circleStyle}
              />
              <div>
                <h4 className="feedback__name">Егор</h4>
              </div>
              <div>
                <span className="feedback_occup">бариста</span>
              </div>
              <div>
                <p className="feedback_desc">
                  Отличная автошкола, грамотный подход к обучению, короткий срок обучения (всё зависит от обучаемого
                  и
                  его
                  настроя), так что рекомендую. Помогают всем учащимся вне зависимости от стажа и опыта вождения.
                </p>
              </div>
            </div>
          </div>
        </Slider>
      </div>
    </Line>
  );
}

export default Reviews;



// WEBPACK FOOTER //
// ./src/components/About/Common/Reviews.jsx